import {
  CLIENT_I18N_INSTANCE,
} from './_state.ts';
import {
  I18N_NAMESPACE,
} from './constants.ts';
import {
  TI18nInstance,
} from './interface.ts';
import {
  messages,
} from './messages.ts';

export function installTranslations(i18n: TI18nInstance) {
  for (const [
    locale,
    message,
  ] of Object.entries(messages)) {
    const namespacedMessages = {
      [I18N_NAMESPACE]: message,
    };
    i18n.global.mergeLocaleMessage(locale, namespacedMessages);
  }

  CLIENT_I18N_INSTANCE.instance = i18n;
}
